import editAlert from 'app/notification/action/alerts/edit'
import alerts from 'app/notification/action/alerts'
import messages from 'app/notification/action/messages'

export default {
  alerts,
  messages,
  editAlert,
}
